// jasa.repo — master Jasa Servis + override harga per cabang. Port JASA/OVR v0.18.
import { supabase } from '@core/supabase';
import type { Service, Outlet } from '@core/types';

export interface JasaInput { nama: string; modal: number; toko: number; user: number; garansi: string; harga_type_toko: 'rp' | 'persen'; harga_type_user: 'rp' | 'persen' }
export interface Override { service_id: number; outlet: string; toko: number; user: number }

export async function listServices(): Promise<Service[]> {
  const { data, error } = await supabase().from('services').select('id,nama,modal,toko,user,garansi,harga_type_toko,harga_type_user').order('nama');
  if (error) throw new Error(error.message);
  return (data ?? []) as Service[];
}
export async function createService(d: JasaInput): Promise<void> {
  const { error } = await supabase().from('services').insert(d); if (error) throw new Error(error.message);
}
export async function updateService(id: number, d: JasaInput): Promise<void> {
  const { error } = await supabase().from('services').update(d).eq('id', id); if (error) throw new Error(error.message);
}
export async function deleteService(id: number): Promise<void> {
  // service_overrides FK on delete cascade → override ikut terhapus
  const { error } = await supabase().from('services').delete().eq('id', id); if (error) throw new Error(error.message);
}

export async function listOutlets(): Promise<Outlet[]> {
  const { data, error } = await supabase().from('outlets').select('kode,nama').order('kode');
  if (error) throw new Error(error.message);
  return (data ?? []) as Outlet[];
}
export async function listOverrides(): Promise<Override[]> {
  const { data, error } = await supabase().from('service_overrides').select('service_id,outlet,toko,user');
  if (error) throw new Error(error.message);
  return (data ?? []) as Override[];
}
export async function upsertOverride(o: Override): Promise<void> {
  const { error } = await supabase().from('service_overrides').upsert(o); if (error) throw new Error(error.message);
}
export async function deleteOverride(serviceId: number, outlet: string): Promise<void> {
  const { error } = await supabase().from('service_overrides').delete().eq('service_id', serviceId).eq('outlet', outlet);
  if (error) throw new Error(error.message);
}
